export default __webpack_public_path__ + "static/media/header-bg2.36ca4637.png";